define(['ko', 'text!./filter-category.html', '_'], function(ko, htmlString, _) {

    // todo: remove duplicate function
    function flattenMyTree(tree) {
        function recurse(nodes, path, pathIds, parentId, parentSlug) {
            return _.map(nodes, function(node) {
                var newPath = _.union(path, [node.name]);
                var newPathIds = _.union(pathIds, [node.id]);
                var newSlug = _.union(parentSlug, [node.slug])
                return [
                    _.assign(
                        {
                            pathname: newPath.join(' > '),
                            url: newSlug.join('/'),
                            level: path.length,
                            pathIds: newPathIds,
                            parentId: parentId
                        },
                        _.omit(node, 'categories')
                    ),
                    recurse(node.categories, newPath, newPathIds, node.id, newSlug),
                ];
            });
        }

        return _.flattenDeep(recurse(tree, []));
    }
    function FacetFilterComponentVM(params) {
        var self = this;
        self.categoryTree = params.categoryTree;
        self.currentCategory = params.currentCategory;
        self.selectedCategory = ko.pureComputed(function (){
            return flattenMyTree(self.categoryTree()).filter(function(c) {
                return c.checked() === true;
            })[0];
        });
        self.level = ko.pureComputed(function () {
            return !_.isUndefined(self.selectedCategory()) ? self.selectedCategory().level : -1;
        })
        self.hasParent = ko.pureComputed(function () {
            return !_.isUndefined(self.selectedCategory()) ? self.selectedCategory().parentId : false;
        });
        self.selectedCategory.subscribe(function (val) {
           if(_.isUndefined(val)) {
               return;
           }

           flattenMyTree(self.categoryTree()).forEach(function(cat) {
               cat.open(_.includes(val.pathIds, cat.id));
           });
        });
    }

    return { viewModel: FacetFilterComponentVM, template: htmlString };
});
